import React from 'react';
import './style.scss';

const ButtonRoaming = ({ type = 'button', children, onClick, className, disabled, ...rest }) => (
  <button
    {...rest}
    disabled={disabled}
    type={type}
    onClick={onClick}
    className={`roaming__btn-custom ${className}`}
  >
    {children}
  </button>
);

export default React.memo(ButtonRoaming)